import Text from "./components/text";
import UserInput from "./components/user-input";
import PhonePreview from "../../../phone-preview";
import Delay from "./components/delay";
import { PREVIEW } from "../../constants/preview";
import Image from "./components/image";
import Gallery from "./components/gallery";

const Preview = (props) => {
   const { faq } = props;
   const cards = faq?.cards ? faq.cards : [];

   const getComponent = (card, index) => {
      const { type } = card;
      switch (type) {
         case PREVIEW.TEXT:
            return <Text key={index} card={card} />
         case PREVIEW.USERINPUT:
            return <UserInput key={index} card={card} />
         case PREVIEW.DELAY:
            return <Delay key={index} card={card} />
         case PREVIEW.IMAGE:
            return <Image key={index} card={card} />
         case PREVIEW.GALLERY:
            return <Gallery key={index} card={card} />
         default:
            break;
      }
   }
   return (
      <div className="preview-wrapper">
         <PhonePreview>
            <div className="preview-messages">
               {cards.map(getComponent)}
            </div>
         </PhonePreview>
      </div>
   )
}

export default Preview;